import { render } from "./JsonField.vue?vue&type=template&id=6e13111e&scoped=true"
import script from "./JsonField.vue?vue&type=script&lang=js"
export * from "./JsonField.vue?vue&type=script&lang=js"

import "./JsonField.vue?vue&type=style&index=0&id=6e13111e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e13111e"]])

export default __exports__